import { useSelector } from 'react-redux';
import { meets, resolvePermissionLevel } from '@/utils/permissionLevel.js';

/**
 * Returns the effective permission level for a component (or page).
 *
 * Usage:
 *   const level = usePermission(COMPONENTS.ROLE_MGMT_MUTATE_SYSTEM_ROLE);
 *   // level === 'FULL_ACCESS' | 'READ_ONLY' | 'NO_ACCESS'
 *
 *   if (level === 'FULL_ACCESS') showEditButton();
 *
 * The componentId format is "{pageId}.{componentName}".
 * The sync script (sync-rbac.mjs) auto-discovers these calls and registers
 * them in rbac-manifest.json — no manual manifest maintenance needed.
 */
export default function usePermission(componentId) {
    const effectivePermissions = useSelector(state => state.effectivePermissions);
    return resolvePermissionLevel(effectivePermissions, componentId);   // null while still loading
}

/**
 * Convenience: check if the resolved level meets a required threshold.
 */
export function useHasPermission(componentId, requiredLevel = 'READ_ONLY') {
    return meets(usePermission(componentId), requiredLevel);
}
